import { privateClient } from '../axiosClients/axiosClients';

export async function sendEmail(params) {
  const response = await privateClient.post('/sendEmail', { ...params });
  return response.data;
}

export async function sendCustomEmail(params) {
  const response = await privateClient.post('/sendCustomEmail', { ...params });
  return response.data;
}
